module.exports = __webpack_public_path__ + "img/s00130.5e582c14.jpg";